// 全画面共通のフッター。著作権表記と作者の X リンクを控えめに表示する
export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white py-4 text-center text-xs text-slate-400">
      © 2026{' '}
      <a
        href="https://x.com/__4ge__"
        target="_blank"
        rel="noreferrer"
        className="text-slate-500 transition hover:text-slate-700 hover:underline"
      >
        4ge (@__4ge__)
      </a>
    </footer>
  );
}
